import ActionCard from "ds/components/ActionCard";
import CollapsibleSection from "ds/components/CollapsibleSection";
import Box from "ds/components/Box";

import LaunchpadKnowledgeBaseCardIndicator from "./CardIndicator";
import { RESOURCES } from "./content";
import { showLaunchPadKnowledgeBaseDrawer } from "./Drawer";

const LaunchPadKnowledgeBase = () => {
  return (
    <CollapsibleSection
      initialIsCollapsed={false}
      title="Knowledge base"
      ariaLevel={2}
      ariaLabel="Knowledge base"
    >
      <Box grid gridTemplate="1fr 1fr 1fr" gap="large">
        {RESOURCES.map(({ title, description, icon, buttonTitle, ...indicatorProps }) => (
          <ActionCard
            key={title}
            title={title}
            icon={icon}
            description={description}
            actionComponent={
              <LaunchpadKnowledgeBaseCardIndicator
                title={title}
                buttonTitle={buttonTitle}
                {...indicatorProps}
                onDrawer={(content, docsLink) => {
                  showLaunchPadKnowledgeBaseDrawer({
                    content,
                    title,
                    docsLink,
                  });
                }}
              />
            }
          />
        ))}
      </Box>
    </CollapsibleSection>
  );
};

export default LaunchPadKnowledgeBase;
